import {put, call, takeEvery} from 'redux-saga/effects';
import  * as constants from "./actions";
import * as Actions from "./constants";
import {toast} from "react-toastify";
import AdminsService from "../../api/services/admins.service";
const _adminsService = new AdminsService();

/**
 * @param loginPayload
 */
function* listTypeDocumentsSaga(loginPayload) {
     const url ='admin/type-documents'
    try {
        const response = yield call(_adminsService.geList,url);
        yield put(constants.typeDocumentsListSuccess(response?.data?.type_documents));
    } catch (error) {
        yield put(constants.typeDocumentsListFailed(error));
        yield call(toast.error,"Un problème est survenu veuillez contacter le service client.")
    }
}

function* documentsByTypeDemandsSaga(loginPayload) {
    const {payload}=loginPayload
    const url =`admin/type-demandes/${payload.type_demande_id}/type-documents`
    try {

        const response = yield call(_adminsService.geList,url);
        yield put(constants.documentsByTypeDemandsSuccess(response?.data?.type_documents));
    } catch (error) {
        yield put(constants.documentsByTypeDemandsFailed(error));
        yield call(toast.error,"Un problème est survenu veuillez contacter le service client.")
    }
}

export default function* typeDocumentsSaga() {
    yield takeEvery(Actions.TYPE_DOCUMENTS_LIST_REQUESTING, listTypeDocumentsSaga);
    yield takeEvery(Actions.DOCUMENTS_BY_TYPE_DEMANDS_REQUESTING, documentsByTypeDemandsSaga);
}
